<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <div style="color: var(--danger);">
      温馨提示：总分润收益为所有设备合计的收益，总分润收益=平台提现收益+空分分润收益+微信商户收益
    </div>

    <!-- 收益数目 -->
    <div class="color052154 mgt-20 leftContent flex aic jcsb">
      <!-- 收益 -->
      <div class="earnings jcsb flex pdl-20 f16 aic withdraw-deposit-btn">
        <div class="month-earnings f20 flex fdc aic jcc">
          <div>
            总分润收益（元）
          </div>
          <div class="mgt-20">
            {{ topForm.totalBalance ? topForm.totalBalance : 0 }}
          </div>
          <div class="btn" @click="symx">设备收益明细</div>
        </div>

        <div class="month-earnings f20 flex fdc aic jcc isHaveDetail">
          <div>平台提现收益（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台提现收益指企业通过提现分润获得的所有收益，平台提现收益=已提现收益+可提现收益+提现待到账收益。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">
            {{
              $calc.jiaFa(
                $calc.jiaFa(topForm.withDrawBalance, topForm.currentBalance),
                topForm.toReceiptBalance
              )
            }}
          </div>
          <!-- <div class="mgt-20">
            3215359.36
          </div> -->
          <div class="pingtaimingxidialogshow" @click="pingtaimingxidialogshow = true">
            平台提现收益明细
          </div>
        </div>

        <div class="month-earnings f20 flex fdc aic jcc isHaveDetail">
          <!-- <div>
            空分分润收益（元）
          </div>
          <div>{{ topForm.kfSharePrice ? topForm.kfSharePrice : 0 }}</div> -->
          <div>空分分润收益（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              空分分润收益指企业通过空中分账方式获得的所有收益。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">
            {{ topForm.kfSharePrice ? topForm.kfSharePrice : 0 }}
          </div>
        </div>

        <div class="month-earnings f20 flex fdc aic jcc isHaveDetail">
          <!-- <div>
            微信商户收益（元）
          </div>
          <div>{{ topForm.subSharePrice ? topForm.subSharePrice : 0 }}</div> -->
          <div>微信商户收益（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              微信商户收益指企业通过微信商户号直接对接分润的所有收益。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">
            {{ topForm.subSharePrice ? topForm.subSharePrice : 0 }}
          </div>
        </div>

        <!-- <div class="month-earnings f20 flex fdc aic jcc">
          <div>
            已提现收益（元）{{
              topForm.withDrawBalance ? topForm.withDrawBalance : 0
            }}
          </div> -->
        <!-- <div class="btn mgt-20" @click="txjl">提现记录</div> -->
        <!-- </div>
        <div class="month-earnings f20 flex fdc aic jcc">
          <div>
            可提现收益（元）{{
              topForm.currentBalance ? topForm.currentBalance : 0
            }}
          </div>
          <div class="btn mgt-20" @click="tx" v-if="this.texy.Total > 0">
            提现
          </div>
        </div>
        <div class="month-earnings f20 flex fdc aic jcc">
          <div>
            待到账收益（元）{{
              topForm.toReceiptBalance ? topForm.toReceiptBalance : 0
            }}
          </div>
        </div> -->
      </div>

      <!-- 表格统计 -->
    </div>

    <!-- 提现 -->
    <!-- 提现记录 -->
    <div class="earningsLists mgt-30">
      <div class="f16 fw-600 mgb-20">提现记录</div>

      <!-- <el-select
        filterable
        v-model="fenqu"
        placeholder="请选择区域"
        clearable
        class="mgr-10"
      >
        <el-option
          v-for="(v, i) in zoneArr"
          :key="i"
          :label="v.regionName"
          :value="v.regionId"
        ></el-option>
      </el-select>

      <el-date-picker
        v-model="startTime"
        format="yyyy-MM-dd"
        type="date"
        placeholder="开始日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      至
      <el-date-picker
        v-model="endTime"
        :picker-options="pickerOptionsEnd"
        format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-button class="mgl-10" type="primary" @click="getFenrun()"
        >查询</el-button
      >
      <el-button
        @click="
          startTime = '';
          endTime = '';
          fenqu = '';
          getFenrun();
        "
        >重置</el-button
      > -->

      <el-table class="mgt-15" :data="fenrunTable" stripe border style="width: 100%">
        <el-table-column type="index" :index="indexMethod" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="withdrawNo" label="提现编号"> </el-table-column>
        <el-table-column prop="customerUser" label="发起人"> </el-table-column>
        <el-table-column prop="createTime" label="提现发起时间">
        </el-table-column>
        <el-table-column prop="totalMoney" label="发起提现金额">
        </el-table-column>
        <el-table-column prop="wxPay" label="打款状态">
          <template slot-scope="scope">
            <span v-text="scope.row.state == 5
                ? '成功'
                : scope.row.state == 6
                  ? '未通过'
                  : '审核中'
              "></span>
          </template>
        </el-table-column>
        <el-table-column prop="receivedMoney" label="应打款金额">
        </el-table-column>
        <el-table-column prop="address" label="打款凭证">
          <template slot-scope="scope">
            <div v-if="scope.row.paymentBill">
              <el-image v-for="(v, i) in scope.row.paymentBill.split(',')" :key="i" style="width: 100px; height: 100px"
                :src="v" :preview-src-list="scope.row.paymentBill.split(',')">
              </el-image>
            </div>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column prop="wxPay" label="备注">
          <template slot-scope="scope">
            <span v-text="scope.row.paymentMsg ? scope.row.paymentMsg : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="wxPay" label="打款时间">
          <template slot-scope="scope">
            <span v-text="scope.row.paymentTime ? scope.row.paymentTime : '- -'"></span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination class="mgt-20" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page" :page-sizes="[5, 20, 30, 40, 50]" :page-size="pageSize" layout=" prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <!-- 提现弹框 -->

    <!-- 发起提现操作确认弹框 -->
    <el-dialog title="操作确认" :visible.sync="dialogFormVisible" center :close-on-click-modal="modalFase">
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="输入银行卡信息"></el-step>
        <el-step title="确认提现金额"></el-step>
        <el-step title="提交确认"></el-step>
      </el-steps>

      <div class="f12 mgb-20 center c0063EA" v-if="active == 0">
        温馨提示:若需修改提现银行卡,请联系工作人员
      </div>
      <div class="f12 mgb-20 center c0063EA" v-if="active == 1">
        温馨提示:已发起提现的分润,不支持重复提交
      </div>
      <div class="f12 mgb-20 center c0063EA" v-if="active == 2">
        确认本次发起提现金额为{{ texy.amount }}元
      </div>
      <el-form :label-position="labelPosition" label-width="auto" hide-required-asterisk :model="affirmform">
        <!-- 第一步 -->
        <div v-if="active == 0">
          <!-- <el-form-item label="收款方户名：">
  
            {{ texy.Account }}
          </el-form-item>
          <el-form-item label="收款方账户：">
      
            {{ texy.account }}
          </el-form-item>
          <el-form-item label="开户行：">
      
            {{ texy.bank }}
          </el-form-item> -->
          <el-form-item label="提现账户">
            <el-select v-model="affirmform.zhanghu" placeholder="请选择提现账户">
              <el-option v-for="(v, i) in zhanghuArr" :key="i" :label="v.payeeNum + '(' + v.bankOfDeposit + ')'"
                :value="v.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 第二步 -->
        <div v-if="active == 1">
          <el-form-item label="当前可提现分润：">
            <!-- <el-input v-model="affirmform.name" autocomplete="off"></el-input> -->
            {{ texy.Total }}
          </el-form-item>
          <el-form-item label="发起提现金额：">
            <el-input v-model="texy.amount" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <!-- 第三步 -->
        <div v-if="active == 2">
          <el-form-item label="收款方户名：">
            {{ payeeName }}
          </el-form-item>
          <el-form-item label="收款方账户：">
            {{ payeeNum }}
          </el-form-item>
          <el-form-item label="开户行：">
            {{ bankOfDeposit }}
          </el-form-item>
        </div>
      </el-form>
      <!-- 下面确认 -->
      <div slot="footer" class="dialog-footer">
        <el-button class="mgr-50" @click="outnext">取 消</el-button>
        <el-button type="primary" @click="next">{{ but2 }}</el-button>
      </div>
    </el-dialog>

    <!-- 收益明细弹框 -->
    <el-dialog title="设备收益明细" :visible.sync="yieldVisible" width="60%" :close-on-click-modal="modalFase" center>
      <el-table :data="yieldData" border stripe style="width: 100%">
        <el-table-column type="index" :index="indexMethod3" label="序号" width="50" fixed="left">
        </el-table-column>
        <!-- <el-table-column prop="orderNo" label="订单编号"> </el-table-column> -->
        <el-table-column prop="createTime" label="设备类型">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType == 1">社区售水机</span>
            <span v-if="scope.row.deviceType == 2">楼宇单元售水机</span>
            <span v-if="scope.row.deviceType == 3">家用净水器</span>
            <span v-if="scope.row.deviceType == 4">户外/公共冰热温净饮机</span>
            <span v-if="scope.row.deviceType == 5">管道纯净水入户</span>
            <span v-if="scope.row.deviceType == 6">富氢水机</span>
          </template>
        </el-table-column>
        <el-table-column prop="payPrice" label="实付金额"> </el-table-column>
        <el-table-column prop="sharePrice" label="分润收益"> </el-table-column>
        <el-table-column prop="kfSharePrice" label="空分分润收益">
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <!-- <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange3"
        @current-change="handleCurrentChange3"
        :current-page="page3"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize3"
        layout=" prev, pager, next"
        :total="total3"
      >
      </el-pagination> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="yieldVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
    <!-- 提现记录弹框 -->
    <el-dialog width="70%" :close-on-click-modal="modalFase" title="提现记录" :visible.sync="recordTableVisible" center>
      <el-table :data="gridData" stripe border>
        <el-table-column type="index" :index="indexMethod" label="序号" width="100">
        </el-table-column>
        <el-table-column property="withdrawNo" label="提现编号"></el-table-column>
        <el-table-column property="customerUser" label="发起人"></el-table-column>
        <el-table-column property="createTime" label="提现发起时间"></el-table-column>
        <el-table-column property="totalMoney" label="发起体现金额（元）"></el-table-column>
        <el-table-column property="state" label="打款状态">
          <template slot-scope="scope">
            <span v-text="scope.row.state == 5
                ? '成功'
                : scope.row.state == 6
                  ? '未通过'
                  : '审核中'
              "></span>
          </template>
        </el-table-column>
        <el-table-column property="receivedMoney" label="实际打款金额（元）"></el-table-column>
        <el-table-column property="paymentTime" label="打款时间">
          <template slot-scope="scope">
            <span v-text="scope.row.paymentTime ? scope.row.paymentTime : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column label="打款凭证">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="lookVoucher(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column property="paymentMsg" label="打款备注">
          <template slot-scope="scope">
            <span v-text="scope.row.paymentMsg ? scope.row.paymentMsg : '- -'"></span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 打款凭证弹框 -->
    <el-dialog :close-on-click-modal="modalFase" title="打款凭证" center :visible.sync="voucherdialogVisible" width="30%">
      <div class="voucherImg">
        <el-image style="width: 50%; height: 100%" :fit="fit" v-if="voucherImgSrc" :preview-src-list="srcList"
          :src="voucherImgSrc">
        </el-image>
        <i v-else class="el-icon-picture-outline">暂无凭证</i>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="voucherdialogVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <el-dialog title="平台提现收益明细" :visible.sync="pingtaimingxidialogshow" width="40%" center top="45vh"
      :close-on-click-modal="false">
      <!-- 表格 -->
       <div>注：已提现收益包含提现审核中的金额</div>
      <el-table class="mgt-15" :data="pingtaimingxiTable" border stripe style="width: 100%">
        <!-- currentBalance,withDrawBalance,toReceiptBalance -->
        <el-table-column prop="withDrawBalance" label="已提现收益（元）">

          <!-- <template slot-scope="scope">
            <div class="flex items-center asdfasdf">
              <div>{{ scope.row.withDrawBalance }}</div>
              <div>
<el-tooltip class="item detailsBtn" placement="right-start">
                <div class="tooltipinfo" slot="content">
                 已提现（包含提现审核中的金额）
                </div>
                <span class="detailsBtn">?</span>
              </el-tooltip>
              </div>
              
            </div>

          </template> -->
        </el-table-column>
        <el-table-column prop="currentBalance" label="可提现收益（元）">
        </el-table-column>
        <el-table-column prop="toReceiptBalance" label="待到账收益（元）">
        </el-table-column>
        <el-table-column prop="toReceiptBalance" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="tx" v-if="texy.Total > 0">提现</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="pingtaimingxidialogshow = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import * as echarts from "echarts";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      texy: {
        Account: "",
        account: "",
        bank: "",
        Total: "",
        amount: "",
      },
      iot: true,
      but2: "下一步",
      modalFase: false,
      labelPosition: "left",
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      // 分页数据
      page3: 1, // 当前页，默认
      pageSize3: 10, //每页显示多少条数据，默认
      total3: 50, // 数据总条数
      tableData: [], //收益列表数据
      withdrawdepositform: {}, //提现弹框数据
      dialogFormVisible: false, //是否打开提现框
      affirmform: {
        name: "",
        name1: "",
        name2: "",
      }, //提现操作确认弹框数据
      affirmFormVisible: false, //是否打开提现操作确认框
      recordTableVisible: false, //是否打开提现记录弹框
      gridData: [{}], //提现记录数据
      voucherdialogVisible: false, //是否打开打款凭证弹框
      voucherImgSrc: "", //打款凭证图片
      topForm: {},
      active: 0, //步骤条
      srcList: [],
      dateQuery: "",
      yearQuery: "",
      monthQuery: "",
      myChart: null,
      fenrunTable: [],
      chartData: [],
      startTime: "",
      endTime: "",
      fenqu: "",
      zoneArr: [],
      yieldVisible: false,
      yieldForm: {},
      yieldData: [],
      zhanghuArr: [],
      pingtaimingxidialogshow: false,
      pingtaimingxiTable: [],

      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      bankOfDeposit: null,
      payeeName: null,
      payeeNum: null,
    };
  },

  watch: {
    startTime() {
      if (this.startTime == null) {
        this.endTime = null;
      }
    },
  },

  created() {
    this.getmonthBill();
    this.getTopData();
    // this.getFenrun();
    // this.getZone()
    this.getxiala();
    this.txjl();
    this.getROLE();
  },
  mounted() {
    // this.getEcharts();
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.getZhanghu(token.companyId);
      }
    },
    getZhanghu(n) {
      this.$api.enterpriseincome.zhanghu({ companyId: n }).then((res) => {
        if (res.code === 200) {
          this.zhanghuArr = res.data;
        }
      });
    },
    symx() {
      this.getYield();
      this.yieldVisible = true;
    },
    getYield() {
      this.$api.enterpriseincome.txShouyiDetail().then((res) => {
        if (res.code === 200) {
          // console.log(res, "收益明细");

          this.yieldData = res.data.rows;
        }
      });
    },
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    dateQueryChange(e) {
      this.getFenrun();
      this.yearQuery = "";
      this.monthQuery = "";
    },
    yearQueryChange(e) {
      this.getFenrun();
      this.dateQuery = "";
      this.monthQuery = "";
    },
    monthQueryChange(e) {
      this.getFenrun();
      this.yearQuery = "";
      this.dateQuery = "";
    },
    getFenrun(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.enterpriseincome
        .fenrunShou({
          pageNum: this.page,
          pageSize: this.pageSize,
          startDay: this.startTime,
          endDay: this.endTime,
          regionId: this.fenqu,
        })
        .then((res) => {
          if (res.code === 200) {
            this.fenrunTable = res.data.rows;
            this.total = res.data.total;
            this.chartData = [];
            res.data.rows.forEach((v) => {
              this.chartData.push({
                value: Number(v.rechargeMoney) + Number(v.wxMoney),
                name: v.regionName,
              });
            });

            this.$nextTick(() => {
              this.getEcharts();
            });
          }
        });
    },

    getxiala() {
      this.$api.enterpriseincome
        .fenrunShou({
          pageNum: 1,
          pageSize: 100,
        })
        .then((res) => {
          if (res.code === 200) {
            this.zoneArr = res.data.rows;
          }
        });
    },

    getEcharts() {
      this.myChart = echarts.init(document.querySelector("#main"));
      this.myChart.clear();
      this.myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: " {b}: {c} ({d}%)",
        },
        legend: {
          show: false,
          top: "5%",
          left: "center",
        },

        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}\n\r\n\r收益：{c}", //设置展示的内容
            },
            emphasis: {
              show: false,
              label: {
                show: false,
                fontSize: 10,
                fontWeight: "bold",
              },
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 20,
                lineStyle: {
                  color: "#333",
                },
              },
            },
            data: this.chartData,
          },
        ],
      });
      // 设置窗口改变时,图表自动缩放
      window.onresize = function () {
        this.myChart.resize();
      };
    },

    getmonthBill() {
      this.$api.enterpriseincome
        .monthBill({ pageNum: this.page, pageSize: this.pageSize })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getTopData() {
      this.pingtaimingxiTable = []
      this.$api.enterpriseincome.topData().then((res) => {
        if (res.code === 200) {
          this.texy.Total = res.data.currentBalance;
          this.topForm = res.data;
          this.pingtaimingxiTable.push(res.data);
        }
      });
    },

    // 改变头部时间选择相对应得数据
    changeTime(item) {
      this.currentHeaderSelect = item;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod2(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod3(index) {
      return index + 1;
    },
    // 表格查看详情按钮，进入详情页面
    godetails(row) {
      this.$router.push({
        path: "/enterpriseincome/enterpriseincome/details",
        query: {
          month: row.month,
        },
      });
    },
    //点击提现事件
    tx() {
      this.affirmform = {};
      this.but2 = "下一步";
      this.$api.enterpriseincome.acquire().then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.texy.Account = data.payeeName;
          this.texy.account = data.payeeNum;
          this.texy.bank = data.bankOfDeposit;
        }
      });
      this.active = 0;
      this.dialogFormVisible = true;
      this.texy.amount = "";
    },
    // 发起提现弹框发起按钮点击事件
    clickwithdrawdeposit() {
      // this.dialogFormVisible = false;
      this.affirmFormVisible = true;
    },
    // 发起提现弹框取消按钮点击事件
    clickcancelwithdrawdeposit() {
      this.$confirm("是否取消提现？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.dialogFormVisible = false;
        this.$message({
          type: "info",
          message: "已取消本次提现",
        });
      });
    },
    //点击提现记录
    txjl(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      // this.recordTableVisible = true;
      this.$api.enterpriseincome
        .withdraw_jl({
          //提现状态
          state: 0,
          pageNum: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 200) {
            //给予提现历史数据

            this.fenrunTable = res.data.rows;
            this.total = res.data.total;
            //凭证
          }
        });
    },
    // 点击提现下一步
    next() {
      console.log(this.active);
      console.log(this.affirmform.zhanghu);

      let reg = /^(?!0+(.0{1,2})?$)\d{1,6}(.\d{1,2})?$/;
      if (
        this.active == 0 &&
        (this.affirmform.zhanghu == "" ||
          this.affirmform.zhanghu == null ||
          this.affirmform.zhanghu == undefined)
      ) {
        this.$message({
          message: "请选择提现账户",
          type: "warning",
        });
        return;
      }

      this.zhanghuArr.forEach((v) => {
        if (this.affirmform.zhanghu == v.id) {
          this.bankOfDeposit = v.bankOfDeposit;
          this.payeeName = v.payeeName;
          this.payeeNum = v.payeeNum;
        }
      });
      if (this.active++ > 2) {
        this.active = 0;
      } else if (this.active == 2) {
        this.but2 = "完成";
        if (reg.test(this.texy.amount) && this.texy.amount <= this.texy.Total) {
          return;
        } else {
          this.$message({
            message: "金额有误,请检查金额",
            type: "warning",
          });
          this.but2 = "下一步";
          this.active--;
        }
      }
      if (this.active == 3) {
        this.$api.enterpriseincome
          .withdraw({
            // 银行卡开户地
            cardAddress: this.bankOfDeposit,
            //银行卡户名
            cardName: this.payeeName,
            //银行卡卡号
            cardNo: this.payeeNum,
            //银行卡类型
            cardType: this.bankOfDeposit,
            //	提现金额
            money: this.texy.amount,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "提现申请已提交",
                type: "success",
              });

              this.txjl();
              this.getTopData();
              // 刷新当前页面
              // window.location.reload();
            }
          });
        this.dialogFormVisible = false;
        this.active = 0;
      }
    },
    //点击取消 并重置表单
    outnext() {
      //弹框取消
      this.dialogFormVisible = false;
      this.active = 0;
      this.affirmform = {};
    },
    // 提现记录查看打款凭证按钮
    lookVoucher(row) {
      this.voucherdialogVisible = true;
      this.voucherImgSrc = row.paymentBill;
      this.srcList = [];
      this.srcList.push(row.paymentBill);
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.txjl(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.txjl(this.page);
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.getYield(this.page3);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange3(val) {
      this.page3 = val;
      this.getYield(this.page3);
    },
  },
};
</script>

<style lang="scss" scoped>
#main {
  // background: var(--card-bg);
  width: 500px;
  height: 200px;
  // margin-top: 20px;
}

.rightContent {
  background: var(--card-bg);
  padding: 10px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.leftContent {
  flex: 1;
  margin-right: 25px;
}

// 头部选择项
.headerSelect {
  .timeSelect {
    padding: 5px 30px;
    border: 1px solid var(--input-border);
    margin-right: 30px;
    cursor: pointer;
  }

  .timeSelect-active {
    padding: 5px 30px;
    border: 1px solid var(--accent);
    background-color: var(--accent);
    margin-right: 30px;
    color: #fff;
    cursor: pointer;
  }
}

// 收益数
.earnings {
  .month-earnings {
    background: var(--card-bg);
    border-radius: 15px;
    width: 300px;
    height: 150px;
    margin-right: 30px;
    box-sizing: border-box;
  }
}

// 提现与提现记录按钮
.withdraw-deposit-btn {
  width: 100%;

  .btn {
    border: 1px solid var(--accent);
    background: var(--card-bg);
    margin-right: 30px;
    // width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    padding: 0 5px;
  }
}

// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

// 提现弹框表单
.el-dialog {
  .el-form {
    margin-left: 50%;
    transform: translateX(-50%);

    .el-input,
    .el-select {
      width: 80%;
    }
  }
}

// 凭证图片
.voucherImg {
  width: 100%;
  height: 200px;
  background-color: #ccc;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
  }

  .el-image {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

// 发起提现
.c0063EA {
  color: var(--accent);
}

.yield {
  .el-form {
    width: 100%;
  }
}

.isHaveDetail {
  position: relative;

  .detailsBtn {
    position: absolute;
    right: 25px;
    top: 20px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    color: #ccc;
    font-size: 14px;
    border: 1px solid var(--input-border);
    border-radius: 100%;
    cursor: pointer;
    padding: 0;
  }
}

.tooltipinfo {
  width: 150px;
}

.pingtaimingxidialogshow {
  padding: 7px 12px;
  border: 1px solid var(--accent);
  border-radius: 10px;
  color: var(--title);
  font-size: 14px;
  cursor: pointer;
}

.statBox {
  width: 300px;
  height: 150px;
  background: var(--card-bg);
  border-radius: 25px;
  color: var(--title);
  font-size: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.asdfasdf{
  position: relative;

  .detailsBtn {
    position: absolute;
        // right: 0;
        left: 50%;
    top: 0;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    color: #ccc;
    font-size: 14px;
    border: 1px solid var(--input-border);
    border-radius: 100%;
    cursor: pointer;
    padding: 0;
  }
}
</style>
